import { Box } from '@factorialco/deprecated-design-system'

import { COMPENSATION_CHANGE_IDS } from 'modules/bookkeepers/store/models/CompensationChange'
import type { IncidenceChangeItem, IncidenceChangeValue } from 'modules/payroll_bundle/lib/types'
import IncidenceCompensationChangesItem from 'modules/payroll_bundle/pages/IncidenceHistoryPage/_IncidenceCompensationChangesItem'

interface Props {
  previousValue?: IncidenceChangeValue
  currentValue?: IncidenceChangeValue
  change: IncidenceChangeItem
}

const AdditionalCompensationHistoryItem = ({ previousValue, currentValue, change }: Props) => {
  const CHANGE_IDS = {
    ...COMPENSATION_CHANGE_IDS,
  }

  return (
    <>
      {(change.id === CHANGE_IDS.compensation_created ||
        change.id === CHANGE_IDS.compensation_updated ||
        change.id === CHANGE_IDS.compensation_deleted) && (
        <Box gap="s16" paddingBottom="s32" width="full">
          <IncidenceCompensationChangesItem
            change={change}
            currentValue={currentValue}
            previousValue={previousValue}
          />
        </Box>
      )}
    </>
  )
}

export default AdditionalCompensationHistoryItem
